module.exports = __webpack_public_path__ + "static/media/recruit_480_default.e4d90b1a.png";